<div ngbDropdown class="d-inline-block w-100">
  <button
    type="button"
    [disabled]="isDisabled"
    class="btn border-top-0 border-start-0 border-end-0 rounded-0 text-left w-100 dropdown-custom"
    ngbDropdownToggle
  >
    <span [ngClass]="value == defaultText ? 'gray' : 'purple semi-bold'" *ngIf="value; else noItem">
      {{ value }}
    </span>
    <ng-template #noItem>{{ defaultText }}</ng-template>
  </button>
  <div ngbDropdownMenu class="dropdown-menu w-100">
    <div *ngFor="let userCourse of userDashboard.userCourses">
      <div *ngIf="userCourse.allowCompare">
        <button ngbDropdownItem [ngClass]="userCourse.courseName === currentSelection ? 'selected' : ''" (click)="selectItem(userCourse.courseName)">
          {{ userCourse.courseName }}
        </button>
      </div>
    </div>
  </div>
</div>
